import type { Contact } from '@/types';
import { toast } from 'sonner';

/** Formats a Contact into a single copyable string. */
export function buildContactText(contact: Contact): string {
  const firstName = contact.first_name || '';
  const lastName = contact.last_name || '';
  const fullName = `${firstName} ${lastName}`.trim();
  const segments: string[] = [];
  if (fullName) segments.push(fullName);
  if (contact.email) segments.push(contact.email);
  if (contact.phone) segments.push(contact.phone);
  return segments.join(' - ');
}

/** Writes contact details to the clipboard and shows a toast notification. */
export async function copyContactToClipboard(
  contact: Contact,
  successMessage: string,
  errorMessage: string,
): Promise<void> {
  try {
    await navigator.clipboard.writeText(buildContactText(contact));
    toast.success(successMessage);
  } catch {
    toast.error(errorMessage);
  }
}
